import { AdFormat, BidderCreativeStatus, MarkupType } from '@openx/types/gqlTypes.ts';
import type { TFunction } from 'i18next';
import type { AdvertiserOption, ContentCategoryOption } from './types.ts';

export const getAdvertiserOptionsMap = (advertiserOptions: AdvertiserOption[]) =>
  advertiserOptions.reduce<Record<string, string>>((acc, account) => {
    const uid = account.exchange_account_network?.uid;

    if (uid) {
      acc[uid] = account.name || uid;
    }

    return acc;
  }, {});

export const getContentCategoryOptionsMap = (contentCategoryOptions: ContentCategoryOption[]) =>
  contentCategoryOptions.reduce<Record<string, string>>((acc, option) => {
    acc[option.id] = option.name || option.id;

    return acc;
  }, {});

/**
 * Get localized labels for ad formats
 */
export const getAdFormatLabels = (t: TFunction): Record<AdFormat, string> => ({
  [AdFormat.Banner]: t('Banner'),
  [AdFormat.Video]: t('Video'),
});

/**
 * Get localized labels for markup types
 */
export const getMarkupTypeLabels = (t: TFunction): Record<MarkupType, string> => ({
  [MarkupType.Html]: t('HTML'),
  [MarkupType.Vast]: t('VAST'),
});

/**
 * Get localized labels for creative status
 */
export const getStatusLabels = (t: TFunction): Record<BidderCreativeStatus, string> => ({
  [BidderCreativeStatus.Active]: t('Active'),
  [BidderCreativeStatus.Paused]: t('Paused'),
});
